import { DataList, PageWrapper, TableFilter } from '@welbe/web-design-system';
import FilesSvg from 'App/assets/img/file-menu-black.svg?url';
import { formattedRows } from './Builder';
import { columns } from './Files.enums';
import { useFiles } from './Files.hooks';
import { Container, LayoutPage } from './Files.styles';
import { FilesFilters } from './components/FilesFilters/FilesFilters';

export const Files = () => {
	const {
		height,
		isFilterOpen,
		setFilterOpen,
		data,
		loading,
		totalPages,
		currentPage,
		handleSearch,
		handleFilters,
		categories,
	} = useFiles();

	return (
		<PageWrapper
			icon={<img src={FilesSvg} alt="Archives Icon" />}
			title="Archivos"
		>
			<Container>
				<TableFilter
					open={isFilterOpen}
					height={height - 300}
					onSearch={handleSearch}
					onClose={() => setFilterOpen(false)}
					onOpen={() => setFilterOpen(true)}
				>
					<FilesFilters
						height={height - 210}
						categories={categories}
						onChangeFilters={handleFilters}
					/>
				</TableFilter>
				<LayoutPage>
					<DataList
						loading={loading}
						headers={columns}
						currentPage={currentPage}
						pagesNumber={totalPages}
						rows={formattedRows(data)}
						height={`${height - 300}px`}
					/>
				</LayoutPage>
			</Container>
		</PageWrapper>
	);
};
